import { render, staticRenderFns } from "./marketplace-details-table.component.vue?vue&type=template&id=256245d5&scoped=true"
import script from "./marketplace-details-table.component.vue?vue&type=script&lang=js"
export * from "./marketplace-details-table.component.vue?vue&type=script&lang=js"
import style0 from "./marketplace-details-table.component.vue?vue&type=style&index=0&id=256245d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256245d5",
  null
  
)

export default component.exports